import { Component, ElementRef, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';
import { UiEventRaised } from '@cmx/shared/feature/platform-configuration';
import { Axis, Dimensions, Legend, SeriesData } from '../charts.model';
import { FieldType } from '@ngx-formly/core';
import { seriesData } from '../chart.data';

@Component({
  selector: 'cmx-bar-horizontal-chart',
  templateUrl: './bar-horizontal-chart.component.html',
  styleUrls: ['./bar-horizontal-chart.component.scss'],
})
export class BarHorizontalChartComponent extends FieldType implements OnInit {
  @Input() data: SeriesData[] = seriesData;

  @Input() dimensions: Dimensions = { width: '', height: '' };
  @Input() allowResize = false;
  @Input() legend: Legend = {
    title: 'Legend',
    position: 'right' || 'below',
    visible: true,
  };
  @Input() axis: Axis = {
    showXAxis: true,
    showYAxis: true,
    xAxisLabel: 'xAxis',
    yAxisLabel: 'yAxis',
    showXAxisLabel: true,
    showYAxisLabel: false,
  };
  @Input() enableAnimations = true;
  @Input() enableGradient = true;
  @Input() showGridLines = true;
  @Input() showDataLabel = false;
  @Input() tooltipDisabled = false;
  @Input() barPadding = 8;
  @Input() isFormlyField = true;
  @Output() raiseBarChartEvent = new EventEmitter<UiEventRaised>();

  view: [number, number] = [500, 300];

  constructor(private element: ElementRef) {
    super();
  }

  ngOnInit() {
    if (this.isFormlyField) {
      this.data = this.to.data || this.data;
      this.allowResize = this.to.allowResize || this.allowResize;

      this.dimensions = this.to.dimensions || this.dimensions;
      this.legend = this.to.legend || this.legend;
      this.axis = this.to.axis || this.axis;
      this.enableAnimations = this.to.enableAnimations || this.enableAnimations;
      this.tooltipDisabled = this.to.tooltipDisabled || this.tooltipDisabled;
      this.enableGradient = this.to.enableGradient || this.enableGradient;
      this.showGridLines = this.to.showGridLines || this.showGridLines;
      this.showDataLabel = this.to.showDataLabel || this.showDataLabel;
      this.barPadding = this.to.barPadding || this.barPadding;
    }
    this.resize(this.dimensions.width, this.dimensions.height);
  }

  onSelect(data: unknown): void {
    this.raiseEvent('horizontal-barchart-clicked', data, false);
  }

  raiseEvent(eventName: string, data: unknown, isNavigation: boolean): void {
    const eventToRaise: UiEventRaised = { eventName, data, isNavigation };
    if (this.isFormlyField) {
      this.to.getFieldEvent(eventToRaise);
    } else {
      this.raiseBarChartEvent.emit(eventToRaise);
    }
  }

  @HostListener('window:resize')
  onWindowResize() {
    this.resize('', this.dimensions.height);
  }

  resize(width?: string | number, height?: string | number, timeout = 0) {
    setTimeout(() => {
      const parentElement = this.element.nativeElement.parentElement.parentElement;
      if (parentElement) {
        this.view = [+(width || parentElement.offsetWidth - 30), +(height || parentElement.offsetHeight - 50)];
      }
    }, timeout);
  }
}
